import { Text, TouchableOpacity, View } from 'react-native';
import { styles } from '../theme';

export const APP_STORE_URL = '#';
export const GOOGLE_PLAY_URL = '#';

export function AppStoreButtons({
  buttonSoonLabel = 'Coming soon',
  downloadLabel = 'Download the app',
}: {
  buttonSoonLabel?: string;
  downloadLabel?: string;
}) {
  return (
    <View style={styles.storeButtons}>
      <Text style={styles.storeButtonsLabel}>{downloadLabel}</Text>
      <View style={styles.storeButtonsRow}>
        <StoreButton label="App Store" platform="ios" soonLabel={buttonSoonLabel} />
        <StoreButton label="Google Play" platform="android" soonLabel={buttonSoonLabel} />
      </View>
    </View>
  );
}

function StoreButton({ label, platform, soonLabel }: { label: string; platform: 'ios' | 'android'; soonLabel: string }) {
  return (
    <TouchableOpacity
      accessibilityRole="button"
      accessibilityState={{ disabled: true }}
      activeOpacity={1}
      style={styles.storeButton}
    >
      <Text style={styles.storeButtonPlatform}>{platform === 'ios' ? '' : '▶'}</Text>
      <View style={styles.storeButtonCopy}>
        <Text style={styles.storeButtonSoon}>{soonLabel}</Text>
        <Text style={styles.storeButtonLabel}>{label}</Text>
      </View>
    </TouchableOpacity>
  );
}
